export default /* css */ `
:host {
  --ui-card-content-padding-left: calc(var(--ui-sys-unit) * 16);
  --ui-card-content-padding-right: calc(var(--ui-sys-unit) * 16);
  --ui-card-content-padding-top: calc(var(--ui-sys-unit) * 16);
  --ui-card-content-padding-bottom: calc(var(--ui-sys-unit) * 16);
}

.ui-card-content {
  padding-left: var(--ui-card-content-padding-left);
  padding-right: var(--ui-card-content-padding-right);
  padding-top: var(--ui-card-content-padding-top);
  padding-bottom: var(--ui-card-content-padding-bottom);
}`
